import React from 'react';
import CoverImage from '@boschebike/ebds-react/dist-esm/components/CoverImage.js';
/**
 * @typedef {import('../types.js').CoverImageProps} CoverImageProps
 */
/**
 * @param {CoverImageProps} props
 * @returns {Element}
 * @constructor
 */

export default (props) => {
  const { url } = props.image.fields.file;
  // TODO: parse it in the ContentfulService, not here!
  const href = url.startsWith('//') ? `https://${url}` : url;

  return (
    <CoverImage
      data-testid="cover-image"
      url={href}
    />
  );
};
